import React from "react";
import Portfolio from "./components/Portfolio";
import './App.css';

const App = () => <Portfolio />;

export default App;
